/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input } from '@angular/core';
import { logWarning } from '@gh/core-util';
import { GridOptions } from 'ag-grid-community';
import { isNil } from 'lodash';

import {
  GRID_FEATURE,
  GridFeature,
  GridFeatureInitParams,
  GridFeatureReadyParams,
} from '../feature.interfaces';

@Directive({
  standalone: false,
  selector: '[ghGridPrecalculatedTreeData]',
  providers: [{
    provide: GRID_FEATURE,
    useExisting: GridPrecalculatedTreeDataDirective,
    multi: true,
  }],
})
export class GridPrecalculatedTreeDataDirective implements GridFeature {
  @Input('ghGridPrecalculatedTreeData') getLevel: TransformFn<Maybe<any>, Maybe<any[]>>;
  @Input('ghGridPrecalculatedTreeDataExpanded') expanded: string;

  initGrid(params: GridFeatureInitParams): void {
    // nothing to do
  }

  enhanceGridOptions(options: GridOptions): void {
    const { getLevel } = this;

    if (isNil(options.getRowId)) {
      throw new Error(`ghGridPrecalculatedTreeData: getRowId should be defined`);
    }

    if (isNil(getLevel)) {
      throw new Error(`ghGridPrecalculatedTreeData: getLevel should be defined`);
    }

    logWarning(
      'ghGridPrecalculatedTreeData: legacy groupStage grouping is no longer applied. ' +
      'Migrate to AG Grid treeData/getDataPath or pre-process hierarchical data.',
    );
  }

  onGridReady(params: GridFeatureReadyParams): void {
    // nothing to do
  }

  onDestroy(): void {
    // nothing to do
  }
}
